import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthStore } from './store';

/**
 * ProtectedRoute —— 包住需要登入的 route。
 * - 首次 mount 觸發 bootstrap()（嘗試 refresh）以支援重新整理還在登入中。
 * - 已 bootstrap 但無 user 則跳 /login?redirect=<原路徑>。
 */
export function ProtectedRoute(): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const bootstrapped = useAuthStore((s) => s.bootstrapped);
  const bootstrap = useAuthStore((s) => s.bootstrap);
  const location = useLocation();

  useEffect(() => {
    void bootstrap();
  }, [bootstrap]);

  if (!bootstrapped) {
    return <div className="text-slate-500">載入中...</div>;
  }

  if (!user) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/login?redirect=${redirect}`} replace />;
  }

  return <Outlet />;
}
